import RedirectionPageOTP from '@/pages/user/RedirectionPageOTP.vue'
import PageAxepta from '@/pages/axepta/PageAxepta.vue'
import PageLoading from '@/components/common/spinner.vue'

export default [
  {
    path: '/profile/',
    component: require('@/pages/user/CMProfile.vue')
  },
  {
    path: '/profile/edit',
    component: require('@/pages/user/CMProfileEdit.vue')
  },
  {
    path: '/profile/changePassword',
    component: require('@/pages/user/CMChangePassword.vue')
  },
  {
    path: '/login/',
    component: require('@/pages/user/CMLogin.vue')
  },
  {
    path: '/OTP/:email/:otp/:ressource',
    component: RedirectionPageOTP
  },
  {
    path: '/register/:FirstName/:LastName/:Login/:Password',
    component: require('@/pages/user/CMRegister.vue')
  },
  {
    path: '/register/',
    component: require('@/pages/user/CMRegister.vue')
  },
  {
    path: '/home/',
    component: require('@/pages/user/Homepage.vue')
  },
  {
    path: '/axepta/',
    component: PageAxepta
  },
  {
    path: '/loading/',
    component: PageLoading
  }
]



// WEBPACK FOOTER //
// ./src/routes/user.js